
import React from "react";
import { Box, IconButton, Tooltip} from "@mui/material";
import { Add, ViewAgenda, FormatSize } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const QuestionnaireFormActionToolbar = ({ onAddQuestion, onAddSection, onAddFreeText }) => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderRadius: 2,
        boxShadow: 3,
        p: 1,
        display: "flex",
        flexDirection: { xs: "row", md: "column" },
        alignItems: "center",
        justifyContent: { xs: "space-evenly", md: "space-between" },
        gap: { xs: 1, md: 1.5 },
        position: "absolute",
        top: { md: 0 },
        right: { md: "-65px" },
        zIndex: 10,
        transition: "all 0.3s ease",
        width: { xs: "100%", md: "auto" },
         mt: { xs: 1.5, md: 0 }
      }}
    >
      <Tooltip title={t('questionnaire.form.actionToolbar.addQuestion')}>
        <IconButton color="primary" onClick={(e) => {
          e.stopPropagation()
          onAddQuestion(e)
        }}>
          <Add />
        </IconButton>
      </Tooltip>

      <Tooltip title={t('questionnaire.form.actionToolbar.addSection')}>
        <IconButton color="secondary" onClick={(e) => {
          e.stopPropagation()
          onAddSection(e)

        }}>
          <ViewAgenda />
        </IconButton>
      </Tooltip>

      <Tooltip title={t('questionnaire.form.actionToolbar.addFreeText')}>
        <IconButton onClick={(e) => {
          e.stopPropagation()
          onAddFreeText()
        }}>
          <FormatSize />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default QuestionnaireFormActionToolbar;
